import { render, staticRenderFns } from "./ModuleStakewiseRewards.vue?vue&type=template&id=95a62f60&scoped=true"
import script from "./ModuleStakewiseRewards.vue?vue&type=script&lang=js"
export * from "./ModuleStakewiseRewards.vue?vue&type=script&lang=js"
import style0 from "./ModuleStakewiseRewards.vue?vue&type=style&index=0&id=95a62f60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a62f60",
  null
  
)

export default component.exports